import { render, staticRenderFns } from "./ganttZoom.vue?vue&type=template&id=52b5fa06&scoped=true&"
import script from "./ganttZoom.vue?vue&type=script&lang=js&"
export * from "./ganttZoom.vue?vue&type=script&lang=js&"
import style0 from "./ganttZoom.vue?vue&type=style&index=0&id=52b5fa06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5fa06",
  null
  
)

export default component.exports